module.exports = __webpack_public_path__ + "img/banner_left.1cc46496.png";